module.exports = __webpack_public_path__ + "img/videoicon.ccf1b608.svg";